// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1aQXH","subtitle":"style_subtitle__3z1MX"};